import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { stack } from 'd3-shape';
import { Apiurl } from '../../Configuration/configuration';


export const signupUser = createAsyncThunk(
  'users/signupUser',
    async ({ name, email, googleid, tokenid, accesstoken, imgurl, familyname, givenName, mob_no, websiteurl }, thunkAPI) => {
    try {
      const response = await fetch(
        `${Apiurl}/api/Login/signupUser`,
        {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
              username : name,
              email: email, 
              googleid: googleid,
              tokenid: tokenid,
              accesstoken: accesstoken,
              imgurl: imgurl,
              familyname: familyname,
              givenName: givenName,
              mob_no: mob_no,
              websiteurl: websiteurl
          }),
        }
      );
      let data = await response.json();
      
      if (data.success == true) {
          localStorage.setItem('token', data.data.accesstoken);
        //   window.open(`https://online.moneysukh.com/signup?email=${email}`, '_blank');
          return { ...data.data, username: name, email: email, isCRMuser: data.data.isCRMuser};
          
        } else {
           return thunkAPI.rejectWithValue(data.data);
      }
    } catch (e) {
     // console.log('Error', e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

 

export const loginUser = createAsyncThunk(
  'users/login',
  async ({ email, password }, thunkAPI) => {
    try {
      const response = await fetch(
        'https://mock-user-auth-server.herokuapp.com/api/v1/auth',
        {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email,
            password,
          }),
        }
      );
      let data = await response.json();
     // console.log('response', data);
      if (response.status === 200) {
        localStorage.setItem('token', data.token);
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
    //  console.log('Error', e.response.data);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);


export const fetchUserBytoken = createAsyncThunk(
    'users/fetchUserByToken',
    async ({ token }, thunkAPI) => {
        try {
            const response = await fetch(
                `${Apiurl}/api/Login/fetchUserBytoken`,
                {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        Accept: 'application/json',                        
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        accesstoken: token,                        
                    }),
                }
            );
            let data = await response.json();
            
            if (data.success == true) {
                
                return { ...data.data };
            } else {
              
                return thunkAPI.rejectWithValue(data.data);
            }
        } catch (e) {
            //console.log('Error', e.response.data);
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


export const forgotpassword = createAsyncThunk(
    'users/forgotpassword',
    async ({ email, mob_no }, thunkAPI) => {
        try {
            const response = await fetch(
                `${Apiurl}/api/Login/forgotpassword`,
                {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        email: email,
                        mob_no: mob_no
                    }),
                }
            );
            let data = await response.json();
            if (data.success == true) {
                return { ...data.data };
            } else {

                return thunkAPI.rejectWithValue(data.data);
            }
        } catch (e) {
            //console.log('Error', e.response.data);
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);




// export const ValidateMobile = createAsyncThunk(
//     'users/ValidateMobile',
//     async ({ email , mob_no }, thunkAPI) => {
//         try {
//             const response = await fetch(
//                 '../../api/Login/ValidateMobile',
//                 {
//                     method: 'POST',
//                     mode: 'cors',
//                     cache: 'no-cache',
//                     credentials: 'same-origin',
//                     headers: {
//                         Accept: 'application/json',
//                         'Content-Type': 'application/json',
//                     },
//                     body: JSON.stringify({
//                         email: email,
//                         mob_no:mob_no
//                     }),
//                 }
//             );
//             let data = await response.json();
//             //console.log("data:" + JSON.stringify(data));

//             if (data.success == true) {
//                 // flg_mobValidated = true
//                 return { ...data.data };
//             } else {
//                 // flg_mobValidated = false
//                 return thunkAPI.rejectWithValue(data.data);
//             }
//         } catch (e) {
//             //console.log('Error', e.response.data);
//             return thunkAPI.rejectWithValue(e.response.data);
//         }
//     }
// );


export const checkvalidotp = createAsyncThunk(
    'users/checkvalidotp',
    async ({ email , otp }, thunkAPI) => {
        try {
            const response = await fetch(
                '../../api/Login/validotp',
                {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        email: email,
                        otp: otp,
                    }),
                }
            );
            let data = await response.json();
            //console.log("data:" + JSON.stringify(data));

            if (data.success == true) {
                return { ...data.data };
            } else {

                return thunkAPI.rejectWithValue(data.data);
            }
        } catch (e) {
            //console.log('Error', e.response.data);
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const userupdatepassword = createAsyncThunk(
    'users/userupdatepassword',
    async ({ email, password }, thunkAPI) => {
        try {
            const response = await fetch(
                '../../api/Login/userupdatepassword',
                {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        email: email,
                        password: password,
                    }),
                }
            );
            let data = await response.json();
            //console.log("data:" + JSON.stringify(data));

            if (data.success == true) {
                return { ...data.data };
            } else {

                return thunkAPI.rejectWithValue(data.data);
            }
        } catch (e) {
          //  console.log('Error', e.response.data);
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);
export const userupdateusername = createAsyncThunk(
    
    'users/userupdateusername',
    async ({ email, username, mob_no, websiteurl}, thunkAPI) => {
        try {
            const response = await fetch(
                '../../api/Login/userupdateusername',
                {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        email: email,
                        username: username,
                        mob_no: mob_no,
                        websiteurl: websiteurl
                    }),
                }
            );
            let data = await response.json();            

            if (data.success == true) {
                return { ...data.data };
            } else {

                return thunkAPI.rejectWithValue(data.data);
            }
        } catch (e) {
          //  console.log('Error', e.response.data);
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const signinemailpassword = createAsyncThunk(
    'users/signinemailpassword',
    async ({  email, password  }, thunkAPI) => {
        try {
            const response = await fetch(
                '../../api/Login/signinemailpassword',
                {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                         
                        email: email,
                        password: password
                        
                    }),
                }
            );
            let data = await response.json();
            if (data.success == true && data.data.flag == true) {
                localStorage.setItem('token', data.data.accesstoken);
                return { ...data.data,  email: email };
            } else {
                return thunkAPI.rejectWithValue(data.data);
            }
        } catch (e) {
            //console.log('Error', e.response.data);
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


export const comejoinus = createAsyncThunk(
    'users/comejoinus',
    async ({ name, email, mobile }, thunkAPI) => {
        try {
            const response = await fetch(
                '../../api/Login/comejoinus',
                {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        name:name,
                        email: email,
                        mobile: mobile

                    }),
                }
            );
            let data = await response.json();
           // console.log("data:" + JSON.stringify(data));
            if (data.success == true && data.data.flag == true) {
                 
                return { ...data.data };
            } else {
                return thunkAPI.rejectWithValue(data.data);
            }
        } catch (e) {
          //  console.log('Error', e.response.data);
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);
 
export const userSlice = createSlice({
  name: 'user',
  initialState: {
    username: '',
    email: '',
    isFetching: false,
    isSuccess: false,
    isError: false,
    isotpflag: false,
    isupdflag: false,
    isnewpassflag: false,
    isusernameflag:false,
    isforgot: false,
    iscomeusjoinflag: false,
    isCRMuser:false,
    errorMessage: '',
    imgurl: '',
    compcode: '',
    compname:'',
    flg_mobValidated : false,
    ProspectStage:"",
    mx_Lead_Status:"",
    mx_Status:"",
  },
  reducers: {
    clearState: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isFetching = false;
      state.flg_mobValidated = false;
      window.localStorage.clear();
      return state;
      },
      setState: (state, { payload }) =>
      {
        state.flg_mobValidated = false;
          state.isSuccess = true;
          state.email = payload.email;
          state.username = payload.name;         
          state.ProspectStage = payload.ProspectStage;         
          state.mx_Lead_Status = payload.mx_Lead_Status;         
          state.mx_Status = payload.mx_Status;         
                  
      },
      setcompcode: (state, { payload }) =>
      {          
          state.compcode = payload.compcode;
          state.compname = payload.compname
          
      }
  },
  extraReducers: {
    [signupUser.fulfilled]: (state, { payload }) => {
      //console.log('payload', payload);
      state.isFetching = false;
      state.isSuccess = true;
      state.email = payload.email;
      state.username = payload.name;
      state.isCRMuser = payload.isCRMuser;
       // console.log('fulfilled isCRMuser:' + payload.isCRMuser);
      return state;         
    },
    [signupUser.pending]: (state) => {
       state.isFetching = true;
    },
    [signupUser.rejected]: (state, { payload }) => {
      
      state.isFetching = false;
      state.isError = true;
      //state.errorMessage = payload.message;
    },
    [loginUser.fulfilled]: (state, { payload }) => {
      state.email = payload.email;
      state.username = payload.name;
      state.isFetching = false;
      state.isSuccess = true;
    //   state.flg_mobValidated = true;
      return state;
    },
    [loginUser.rejected]: (state, { payload }) => {
      //console.log('payload', payload);
      state.isFetching = false;
      state.isError = true;
      //state.errorMessage = payload.message;
    },
    [loginUser.pending]: (state) => {
      state.isFetching = true;
    },


    [fetchUserBytoken.pending]: (state) => {
      state.isFetching = true;
    },
    [fetchUserBytoken.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = true;
        state.isError = false;
      state.email = payload.email;
        state.username = payload.name;
        state.imgurl = payload.imgurl;
    },
    [fetchUserBytoken.rejected]: (state) => {
      //console.log('fetchUserBytoken');
      state.isFetching = false;
      state.isError = true;
    },
      [forgotpassword.pending]: (state) => {
          state.isFetching = true;
      },
      [forgotpassword.fulfilled]: (state, { payload }) => {
          //console.log('forgotpassword payload', JSON.stringify(payload));
          state.isFetching = false;
          state.isSuccess = false;
          state.isError = false;
          state.isforgot = true;
          state.email = payload.email;          
      },
      [forgotpassword.rejected]: (state) => {
          //console.log('forgotpassword');
          state.isFetching = false;
          state.isError = true;
      },
      [checkvalidotp.fulfilled]: (state, { payload }) => {
          //console.log('checkvalidotp payload', JSON.stringify(payload));
          state.isFetching = false;
          state.isSuccess = false;
         
          state.email = payload.email;
          state.isotpflag = payload.flag;
          //console.log('checkvalidotp state', JSON.stringify(state));
          return state;
      },
      [checkvalidotp.pending]: (state) => {
          state.isFetching = true;
      },
      [checkvalidotp.rejected]: (state, { payload }) => {

          state.isFetching = false;
          state.isError = true;
          //state.errorMessage = payload.message;
      },
      [userupdatepassword.fulfilled]: (state, { payload }) => {
          //console.log('updatepassword payload', JSON.stringify(payload));
          state.isFetching = false;
          state.isSuccess = false;
          state.email = payload.email;
          state.isupdflag = payload.updflag;
          state.isnewpassflag = payload.updnameflag;
          //console.log('updatepassword state', JSON.stringify(state));
          return state;
      },
      [userupdatepassword.pending]: (state) => {
          state.isFetching = true;
      },
      [userupdatepassword.rejected]: (state, { payload }) => {

          state.isFetching = false;
          state.isError = true;
          //state.errorMessage = payload.message;
      },
      [userupdateusername.fulfilled]: (state, { payload }) => {
          //console.log('userupdateusername payload', JSON.stringify(payload));
          state.isFetching = false;
          state.isSuccess = false;
          state.email = payload.email;
          state.isusernameflag = payload.updusernameflag;          
          //console.log('userupdateusername state', JSON.stringify(state));
          return state;
      },
      [userupdateusername.pending]: (state) => {
          state.isFetching = true;
      },
      [userupdateusername.rejected]: (state, { payload }) => {

          state.isFetching = false;
          state.isError = true;
          //state.errorMessage = payload.message;
      },
      [signinemailpassword.fulfilled]: (state, { payload }) => {
          //console.log('signinemailpassword payload', JSON.stringify(payload));
          state.isFetching = false;
          state.isSuccess = payload.flag;
          state.email = payload.email;
          state.accesstoken = payload.accesstoken;
          state.imgurl = payload.imgurl;
          state.isCRMuser = payload.isCRMuser;
          //console.log('signinemailpassword state', JSON.stringify(state));
          return state;
      },
      [signinemailpassword.pending]: (state) => {
          state.isFetching = true;
      },
      [signinemailpassword.rejected]: (state, { payload }) => {

          state.isFetching = false;
          state.isError = true;
          //console.log('signinemailpassword rejected state', JSON.stringify(state));
          //state.errorMessage = payload.message;
      },
      [comejoinus.fulfilled]: (state, { payload }) => {
          //console.log('comejoinus payload', JSON.stringify(payload));
          state.isFetching = true;
          state.iscomeusjoinflag = payload.flag;
          
          //console.log('signinemailpassword state', JSON.stringify(state));
          return state;
      },
      [comejoinus.pending]: (state) => {
          state.isFetching = true;
      },
      [comejoinus.rejected]: (state, { payload }) => {

          state.isFetching = false;
          state.isError = true;
          //console.log('comejoinus rejected state', JSON.stringify(state));
          //state.errorMessage = payload.message;
      },
    //   [ValidateMobile.fulfilled]: (state, { payload }) => {
    //     state.flg_mobValidated = true;
    //     return state;
    //   },
    //   [ValidateMobile.rejected]: (state, { payload }) => {
    //     state.flg_mobValidated = false;
    //   },
    //   [ValidateMobile.pending]: (state) => {
    //     state.flg_mobValidated = false;
    //   },
  },
});

export const { clearState, setState, setcompcode } = userSlice.actions;
export const userSelector = (state) => state.user;
 
 
 